import { IDelivery } from './models/IDelivery';
import moment from 'moment';
import FileSaver from 'file-saver';

export default class ExportHelper {


    public static buildAndDownloadCsv(data: IDelivery[]): void {
        let csvContent = "Dato,Bilagsnummer, Vekt\r\n";

        data.forEach((d) => {
            let fiteredObject = { 
                time: d.time,
                bilagsnummer: d.bilagsnummer,
                vekt: d.vekt
            }
            csvContent += Object.values(fiteredObject).join(",");
            csvContent += "\r\n";
        });
        const blob = new Blob([csvContent], {type: 'data:text/csv;charset=utf-8;'});

        const filename = 'leveranser-' + moment().format('DD-MM-YYYY') + '.csv';

        this.saveFileFromBlob(filename, blob);
    }
    // FileSaver.js 
    public static saveFile(filename: string, data: any): void {
        this.saveFileFromBlob(filename, new Blob([data]));
    }

    public static saveFileFromBlob(filename, blob: Blob){
        let url = window.URL.createObjectURL(blob);           
        FileSaver.saveAs(url, filename);  
    }
}